import DateCell from './DateCell'

// Week day labels (Sunday to Saturday)
const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

/**
 * CalendarGrid Component
 * Renders the calendar grid with week day headers and date cells
 *
 * @param {Object} props - Component props
 * @param {DateTime[]} props.dates - Array of 42 Luxon DateTime objects (6 weeks)
 * @param {Function} props.onDateClick - Callback when date is clicked
 * @param {string} props.selectedDate - Currently selected date (YYYY-MM-DD)
 * @param {Set} props.availableDates - Set of available dates
 * @param {DateTime} props.currentMonth - Current month being displayed
 */
const CalendarGrid = ({ dates, onDateClick, selectedDate, availableDates, currentMonth }) => {
  return (
    <div className="p-4">
      {/* Week day headers */}
      <div className="grid grid-cols-7 gap-1 mb-2">
        {WEEKDAY_LABELS.map(day => (
          <div
            key={day}
            className="text-center text-xs font-semibold text-gray-600 py-2"
          >
            {day}
          </div>
        ))}
      </div>

      {/* Date grid (7 columns × 6 rows = 42 cells) */}
      <div className="grid grid-cols-7 gap-1">
        {dates.map((date, index) => (
          <DateCell
            key={index}
            date={date}
            onDateClick={onDateClick}
            selectedDate={selectedDate}
            availableDates={availableDates}
            currentMonth={currentMonth}
          />
        ))}
      </div>
    </div>
  )
}

export default CalendarGrid
